export const blogActionType = {
  GET: "blog/get",
  THUNK: "blog/thunk",
};
